import { Clock, Wallet, ArrowRight } from "lucide-react";
import { priceLabel } from "./utils";
import { useBT } from "./i18n";

export const ServicePicker = ({ catalog, activeCat, setActiveCat, onPick }) => {
  const { t } = useBT();
  const cats = catalog.categories.filter((c) => c.visible);
  const services = catalog.services.filter((s) => s.category_id === activeCat);
  return (
    <section data-testid="book-step-service">
      <div className="flex gap-2 flex-wrap">
        {cats.map((c) => (
          <button key={c.id} data-testid={`book-category-${c.slug}`} onClick={() => setActiveCat(c.id)}
            className={`px-5 py-2.5 rounded-full text-sm transition-colors ${
              activeCat === c.id ? "bg-[#15262d] text-white" : "bg-white border hover:border-[#15262d]"}`}>
            {c.name}
          </button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-4 mt-8">
        {services.map((s, i) => (
          <button key={s.id} data-testid={`book-service-${s.slug}`} onClick={() => onPick(s)}
            style={{ animationDelay: `${i * 60}ms` }}
            className="group text-left bg-white border rounded-xl p-6 flex flex-col hover:border-[#b09873] hover:-translate-y-0.5 transition-[transform,border-color] duration-300 animate-in fade-in slide-in-from-bottom-2 fill-mode-both">
            <h3 className="font-medium">{s.name}</h3>
            <p className="text-sm text-[#1d2b31]/60 mt-1">{s.short_description}</p>
            <div className="flex items-center gap-4 mt-4 text-xs text-[#1d2b31]/60">
              {!s.hide_duration && <span className="flex items-center gap-1"><Clock size={13} /> {s.duration_min} min</span>}
              <span className="flex items-center gap-1"><Wallet size={13} /> {priceLabel(s, t)}</span>
              {catalog.payments_enabled && s.deposit_enabled && s.deposit_amount > 0 && (
                <span className="text-[#8a7347]" data-testid={`book-service-deposit-${s.slug}`}>{t.deposit} €{s.deposit_amount}</span>
              )}
            </div>
            <span className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#15262d] group-hover:text-[#8a7347] transition-colors">
              {t.chooseDate} <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
        ))}
        {services.length === 0 && <p className="text-sm text-[#1d2b31]/50">{t.noServices}</p>}
      </div>
    </section>
  );
};
